import { useState, useEffect } from 'react';
import { fetchCountryCode, getAdapter, DEFAULT_COUNTRY } from './index';

// Loads the current account owner's fiscal country and exposes the matching
// adapter. Mirrors useFeatures() — country flags gate country-specific fiscal
// behaviour (tax math, identifiers, e-invoice), the same way feature flags gate
// whole modules.
//
//   const { adapter, countryCode, loading } = useFiscalAdapter();
//   const totals = adapter.computeTotals(lines, opts);
//
// Never returns null: falls back to the default-country adapter while loading
// or on error, so consumers can render without guarding.
export function useFiscalAdapter() {
  const [countryCode, setCountryCode] = useState(DEFAULT_COUNTRY);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchCountryCode()
      .then((code) => { if (active) { setCountryCode(code); setLoading(false); } })
      .catch(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return { adapter: getAdapter(countryCode), countryCode, loading };
}
